module.exports = __webpack_public_path__ + "img/瑞香狼毒.0dfc7a88.jpg";